/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { DEVICE_BP_DESKTOP_MIN } from "~/constants";

export const FIXED_HEADER_HEIGHT = 76;
export const PAGE_HEADER_HEIGHT = 187;
export const HEADER_SCROLL_OFFSET = 0;

export const JSS_MEDIA_HEADER_IMAGE_MAX = `@media (max-width: ${DEVICE_BP_DESKTOP_MIN - 1}px)`;

export enum AuthenticatedMenuItem {
  "DASHBOARD" = "dashboard",
  "STATISTICS" = "statistics",
  "PROMO_TOOLS" = "promo_tools",
  "MY_SITES" = "my_sites",
  "MANAGE_SITES" = "manage_sites",
  "CREATE_NEW_SITE" = "create_new_site",
  "POSTBACKS" = "postbacks",
  "SUPPORT" = "support",
  "FAQ" = "faq",
  "API" = "api",
  "CONTACT" = "contact",
  "ENCODE" = "encode",
  "DECODE" = "decode",
  "MY_ACCOUNT" = "my_account",
  "MY_DETAILS" = "my_details",
  "PAYOUT_INFO" = "payout_info",
  "DOCUMENTS" = "documents",
  "PERSONAL_INFORMATION" = "personal_information",
  "EMAIL_PREFERENCES" = "email_preferences",
  "LOGOUT" = "logout",
}

export enum GuestMenuItem {
  "ABOUT" = "about",
  "PARTNERS" = "partners",
  "PROGRAMS" = "programs",
  "TOOLS" = "tools",
  "CONTACT" = "contact",
  "SIGNUP" = "signup",
  "LOGIN" = "login",
}
